<template>
  <div>
    <div id="_type">
      <div class="content_div">
        <div class="system_div"
             style="margin:0 auto;text-align: left;">
          <!--          <div class="container col-12 module" style="height:70px;text-align: left;z-index: 11;position:relative;"></div>-->
          <div>
            <div class="wenbenleixing_div clearfix">

              <div class="wenbenleixing_menu_div">
                <div class="wenbenleixing_menu_body_div">
                  <router-link :to="'/index'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div company_announcement"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='index'}">
                        <span>首页</span>
                      </div>
                    </div>
                  </router-link>
                  <router-link :to="'/gsgg'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div company_announcement"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='gsgg'}">
                        <span>公司公告</span>
                      </div>
                    </div>
                  </router-link>
                  <router-link :to="'/xwbd'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div news_report"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='xwbd'}">
                        <span>新闻报道</span>
                      </div>
                    </div>
                  </router-link>
                  <router-link :to="'/yjbg'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div research_report"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='yjbg'}">
                        <span>研究报告</span>
                      </div>
                    </div>
                  </router-link>
                  <router-link :to="'/gsjg'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div company_supervision"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='gsjg'}">
                        <span>公司研究</span>
                      </div>
                    </div>
                  </router-link>
                  <router-link :to="'/qtwb'">
                    <div class="wenbenleixing_navigation_div">
                      <div class="wenbenleixing_navigation_blueModel_div other_text"
                           :class="{selectType:($route.params.type?$route.params.type:'gsgg')=='qtwb'}">
                        <span>综合文本</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <!--0.首页-->
              <div v-if="($route.params.type?$route.params.type:'gsgg').indexOf('index111')>-1">
                <div class="headwapper">
                  <search-input @showHistory='showHistoryModel' :database="database"></search-input>
                </div>
              </div>
              <!--1.公司公告-->
              <div class="auto-container"
                   v-if="($route.params.type?$route.params.type:'gsgg').indexOf('gsgg')>-1 || ($route.params.type?$route.params.type:'gsgg').indexOf('index')>-1">
                <h2 class="centertitle">公司公告</h2>
                <div class="wrapper-box">
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><i class="iconfont icon-nianbao"></i></div>
                        <h4><a href="#">年报</a></h4>
                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','nb')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zijintouxiang"></span></div>
                        <h4><a href="#">上市公司季报和中报</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','zbjb')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-taolun"></span></div>
                        <h4><a href="#">管理层讨论与分析</a></h4>
                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','CMDA')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zhaobiao"></span></div>
                        <h4><a href="#">招股说明书</a></h4>
                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','zgs')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-weigui"></span></div>
                        <h4><a href="#">违规违纪</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','违规违纪')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-fengxian"></span></div>
                        <h4><a href="#">风险提示</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','风险提示')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zhengce"></span></div>
                        <h4><a href="#">政策影响</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','政策影响')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-yichang"></span></div>
                        <h4><a href="#">交易异动</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','交易异动')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-chengqing"></span></div>
                        <h4><a href="#">澄清公告</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','澄清公告')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-guquan"></span></div>
                        <h4><a href="#">股份增减持</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','股份增减持')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-guquanjili"></span></div>
                        <h4><a href="#">股权激励</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','股权激励')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-duliyijian"></span></div>
                        <h4><a href="#">独立董事意见</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','IDRD')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-shehui"></span></div>
                        <h4><a href="#">社会责任报告</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','社会责任报告')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-guanlianjiaoyi"></span></div>
                        <h4><a href="#">关联交易</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','关联交易')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-lirunfenpei"></span></div>
                        <h4><a href="#">利润分配</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','利润分配')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-danbao"></span></div>
                        <h4><a href="#">担保事项</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','担保事项')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-gaoguanbiandong"></span></div>
                        <h4><a href="#">高管变动</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','高管变动')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-diya"></span></div>
                        <h4><a href="#">抵押借贷</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','抵押借贷')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">-->
                    <!--                      <div class="card feature fx-border" style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>-->
                    <!--                        <div class="icon"><span class="iconfont icon-gudong"></span></div>-->
                    <!--                        <h4><a href="#">股东大会报告</a></h4>-->
                    <!--                        -->
                    <!--                        <div class="link-btn">-->
                    <!--                          <span @click="gotoTarget('gsgg','股东大会报告')" class="btnanimate enterbtn enter"><span>进入</span></span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-shougoujianbing"></span></div>
                        <h4><a href="#">收购兼并</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','收购兼并')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">-->
                    <!--                      <div class="card feature fx-border" style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>-->
                    <!--                        <div class="icon"><span class="iconfont icon-binggouchongzu"></span></div>-->
                    <!--                        <h4><a href="#">并购重组</a></h4>-->
                    <!--                        -->
                    <!--                        <div class="link-btn">-->
                    <!--                          <span @click="gotoTarget('gsgg','并购重组')" class="btnanimate enterbtn enter"><span>进入</span></span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-tingpai"></span></div>
                        <h4><a href="#">停牌公告</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','停牌公告')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zengfa"></span></div>
                        <h4><a href="#">增发预案</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','增发预案')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-dongjie"></span></div>
                        <h4><a href="#">质押冻结</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','质押冻结')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-guquanfenzhigaige"></span></div>
                        <h4><a href="#">股权分置改革</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','股权分置改革')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-falv"></span></div>
                        <h4><a href="#">法律纠纷</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','法律纠纷')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-touzilicai"></span></div>
                        <h4><a href="#">投资理财</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','投资理财')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zichan"></span></div>
                        <h4><a href="#">资产重组</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','资产重组')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zijintouxiang"></span></div>
                        <h4><a href="#">资金投向</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsgg','资金投向')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--2.新闻报道-->
              <div class="auto-container"
                   v-if="($route.params.type?$route.params.type:'gsgg').indexOf('xwbd')>-1">
                <h2 class="centertitle">新闻报道</h2>
                <div class="wrapper-box">
                  <div class="row">
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-gubapinglun"></span></div>
                        <h4><a href="#">股吧评论</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('xwbd','GUBA_CNRDS')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><i class="iconfont icon-gongsixw"></i></div>
                        <h4><a href="#">公司新闻</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('xwbd','CFND_HighTrail')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
<!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-hangyexw"></span></div>
                        <h4><a href="#">行业新闻</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('xwbd','行业新闻')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>-->
                    <!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">-->
                    <!--                      <div class="card feature fx-border" style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>-->
                    <!--                        <div class="icon"><span class="iconfont icon-hongguanxw"></span></div>-->
                    <!--                        <h4><a href="#">宏观新闻</a></h4>-->
                    <!--                        -->
                    <!--                        <div class="link-btn">-->
                    <!--                          <span @click="gotoTarget('xwbd','宏观新闻')" class="btnanimate enterbtn enter"><span>进入</span></span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">-->
                    <!--                      <div class="card feature fx-border" style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>-->
                    <!--                        <div class="icon"><span class="iconfont icon-caijingxw"></span></div>-->
                    <!--                        <h4><a href="#">财经新闻</a></h4>-->
                    <!--                        -->
                    <!--                        <div class="link-btn">-->
                    <!--                          <span @click="gotoTarget('xwbd','财经新闻')" class="btnanimate enterbtn enter"><span>进入</span></span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                    <div class="   col-lg-3 col-md-4 col-sm-6 ">-->
                    <!--                      <div class="card feature fx-border" style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>-->
                    <!--                        <div class="icon"><span class="iconfont icon-gushixw"></span></div>-->
                    <!--                        <h4><a href="#">股市新闻</a></h4>-->
                    <!--                        -->
                    <!--                          股市新闻数据库包括2001年以来沪深A股上市公司股市新闻的基本信息、词频统计、语调分析、可读性、相似性五个重要模块。-->
                    <!--                        </div>-->
                    <!--                        <div class="link-btn">-->
                    <!--                          <span @click="gotoTarget('xwbd','股市新闻')" class="btnanimate enterbtn enter"><span>进入</span></span>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->

                  </div>
                </div>
              </div>
              <!--3.研究报告-->
              <div class="auto-container"
                   v-if="($route.params.type?$route.params.type:'gsgg').indexOf('yjbg')>-1">
                <h2 class="centertitle">研究报告</h2>
                <div class="wrapper-box">
                  <div class="row">
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><i class="iconfont icon-fenxishi"></i></div>
                        <h4><a href="#">公司研究</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','AnalystReport')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-chenhui"></span></div>
                        <h4><a href="#">晨会报告</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','晨会报告')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-celve"></span></div>
                        <h4><a href="#">宏观策略</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','宏观策略')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-hangyeyanjiu"></span></div>
                        <h4><a href="#">行业研究</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','行业研究')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-zhaiquanyanjiu"></span></div>
                        <h4><a href="#">债券研究</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','债券研究')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-qihuo"></span></div>
                        <h4><a href="#">期货研究</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('yjbg','期货研究')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <!--4.公司研究-->
              <div class="auto-container"
                   v-if="($route.params.type?$route.params.type:'gsgg').indexOf('gsjg')>-1">
                <h2 class="centertitle">公司研究</h2>
                <div class="wrapper-box">
                  <div class="row">
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><i class="iconfont icon-wenxun"></i></div>
                        <h4><a href="#">监管问询</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','Regulatory')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-yeji"></span></div>
                        <h4><a href="#">业绩说明会</a></h4>
                        <Poptip trigger="hover"
                                width="304"
                                word-wrap
                                content="业绩说明会数据库是基于上市公司每年在交易所发布的业绩说明会上的提问与回答内容的文本信息进行整理和分析生成的专业文本分析数据库。包括基本信息、词频统计、语调分析、可读性四个重要模块。">

                        </Poptip>
                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','PFBF')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-luyan"></span></div>
                        <h4><a href="#">IPO路演</a></h4>
                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','Ipors')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>

                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-shenji"></span></div>
                        <h4><a href="#">关键审计事项</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','KADI')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-wenda"></span></div>
                        <h4><a href="#">投资者问答</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','invQA')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-wenda"></span></div>
                        <h4><a href="#">上市公司调研报告</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('gsjg','上市公司调研报告')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--5.综合文本-->
              <div class="auto-container"
                   v-if="($route.params.type?$route.params.type:'gsgg').indexOf('qtwb')>-1">
                <h2 class="centertitle">综合文本</h2>
                <div class="wrapper-box">
                  <div class="row">
                    <!-- <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-caipanwenshu"></span></div>
                        <h4><a href="#">公司裁判文书</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('qtwb','Referee')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div> -->
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-quanshang"></span></div>
                        <h4><a href="#">券商年报</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('qtwb','QSNB')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="   col-lg-3 col-md-4 col-sm-6 ">
                      <div class="card feature fx-border"
                           style="visibility: visible;"><span class="fx-border-top"></span><span class="fx-border-right"></span><span class="fx-border-bottom"></span><span class="fx-border-left"></span>
                        <div class="icon"><span class="iconfont icon-yinhang"></span></div>
                        <h4><a href="#">银行年报</a></h4>

                        <div class="link-btn">
                          <span @click="gotoTarget('qtwb','YHNB')"
                                class="btnanimate enterbtn enter"><span>进入</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackTop :height="200"
               :bottom="50"
               :right="50">
      </BackTop>
    </div>

    <!--    模态框-->
    <div>
      <Modal v-model="showmodal"
             footer-hide>
        <p style="text-align: center;margin-top: 15px">
          <i class="iconfont icon-xiaolian"></i>
        </p>
        <p style="text-align: center;font-size: 14px;line-height: 1.6rem;margin: 10px auto;margin-bottom: 25px;">尊敬的用户<br>您当前所使用账号暂无权限浏览和下载该数据<br>如需使用该数据，请您<a @click="changeShowModel"
             href="#contact"
             data-toggle="modal"
             data-target=".contactUs">联系我们</a></p>
      </Modal>
    </div>
    <!--    模态框结束-->


  </div>

</template>
<style scoped lang="scss">
// head{
//     transition: ease all 0.5s;
//     -webkit-transition: ease all 0.5s;
//     -moz-transition: ease all 0.5s;
//     -ms-transition: ease all 0.5s;
// }
.featureWarning_bottom_div {
  width: 100%;
  height: 35px;
  line-height: 35px;
}

.continue_button {
  background: #0e90d2;
  color: white;
  border: 0px;
  width: 110px;
  border-radius: 5px;
}

.col-sm-3 {
  margin-bottom: 20px;
  margin-top: 20px;
  img {
    cursor: pointer;
  }
}

#_type {
  width: 100%;
  min-height: 860px;
  margin: 0;
  padding: 0;
  overflow: auto;
}

.line_left {
  border-bottom: 1px solid black;
  width: 150px;
  position: absolute;
  margin-left: -40px;
  margin-top: 38px;
}

.line_rifht {
  border-bottom: 1px solid black;
  width: 750px;
  position: absolute;
  margin-top: -32px;
  margin-left: 410px;
}

.content_div {
  height: 100%;
  // width: 1020px;
  width: 1260px;
  margin: 0 auto;
  position: relative;
}

.function_content_div {
  width: 252px;
  margin: 0 auto;
  text-align: center;
  margin-top: 30px;
}

.auto-container .active {
  line-height: 35px;
  font-weight: 700;
  background-color: rgba(215, 215, 215, 1);
  height: 60px;
}

ul {
  display: inline;
  white-space: nowrap;
}

ul li {
  padding: 10px 70px;
  display: inline-block;
  white-space: nowrap;
  cursor: pointer;
}

wenbenleixing_div {
  margin: 0px auto;
  width: 1300px;
  background-color: white;
  position: relative;
  margin-bottom: 20px;
  margin-top: 15px;
  /* border-top: 1px solid #ccc; */
}

.wenbenleixing_menu_div {
  /* width: 280px; */
  float: left;
  display: none;
  position: relative;
}

.wenbenleixing_menu_body_div {
  width: 200px;
  height: 100%;
  margin: 0 auto;
}

.wenbenleixing_navigation_div {
  height: 100px;
  width: 200px;
  /* margin-top: 29px; */
  position: relative;
}

.wenbenleixing_navigation_blueModel_div {
  width: 130px;
  height: 50px;
  line-height: 40px;
  top: 25px;
  text-align: center;
  color: black;
  position: absolute;
  background-color: rgba(242, 242, 242, 1);
  cursor: pointer;
}

.wenbenleixing_navigation_blueModel_div span {
  position: relative;
  top: 5px;
}

.wenbenleixing_title {
  /* padding-top: 20px; */
  width: 1260px;
  margin: 0 auto;
  /* margin-right: -26px; */
  text-align: center;
}

.selectType {
  cursor: auto;
  background: rgba(71, 136, 207, 1);
  color: #fff;
}

#left1 .col-sm-3 {
}

_:-ms-fullscreen,
:root .ie11up {
  property: value;
}

.gsgg_navbar1 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

.gsgg_navbar2 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

.xwbd_navbar1 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

.yjbg_navbar1 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

.gsjg_navbar1 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

.qtwb_navbar1 {
  width: 200px;
  height: 160px;
  padding-top: 30px;
}

/* Services Section */

.card {
  position: relative;
  background-color: #fff;
  margin-bottom: 30px;
  text-align: center;
  padding: 30px;
  transition: 0.5s;
  border: 1px solid #ededed;
  padding-bottom: 39px;
  border-radius: 7px;
  box-shadow: 0 3px 24px rgba(0, 0, 0, 0.04);
  height: 250px;
}

.auto-container .icon {
  position: relative;
  width: 75px;
  height: 75px;
  line-height: 65px;
  text-align: center;
  margin: 11px auto;
  font-size: 50px;
  border-radius: 50%;
  transition: 0.5s;
}

.auto-container .card:hover .iconfont {
  color: #2071c0;
  transition: 0.5s;
}

.auto-container .iconfont {
  font-size: 36px;
  color: #4e4e4e;
  transition: 0.5s;
}

.auto-container .icon-font {
  font-family: "iconfont" !important;
}

.auto-container h4 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #636363;
}

.auto-container h4 a {
  color: #061a3a;
  //transition: .5s;
}

//.text {
//    position: relative;
//    margin-bottom: 15px;
//    color: #636363;
//    font-size: 12px;
//}

.wrapper-box {
  position: relative;
}

/* color */

.auto-container a:hover,
.auto-container a {
  color: #2071c0;
}

.auto-container .icon {
  color: #2071c0;
}

.auto-container .icon:before {
  background-color: #2071c0;
}

//.card:hover h4 a{
//    color: #2071c0;
//}
.auto-container .card:hover .enterbtn {
  color: white;
}
.auto-container .enterbtn.enter:hover {
  color: #4184f3;
  box-shadow: 0 15px 40px 0 rgba(32,81,171,20%);
}
/* button */

.btnanimate {
  display: inline-block;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
}
.enterbtn {
  position: relative;
  display: inline-block;
  font-size: 14px;
  line-height: 5px;
  color: #fff;
  font-weight: 500;
  border-radius: 32px 0 32px 32px;
  overflow: hidden;
  text-transform: capitalize;
  vertical-align: middle;
  box-shadow: 0px 15px 40px 0px rgba(32, 81, 171, 0.2);
}

.enterbtn:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0%;
  content: "";
  background-color: white;
  transition: 0.5s;
  border-radius: 32px 0 32px 32px;
}

.enterbtn:hover:before {
  width: 100%;
}

.enterbtn span {
  position: relative;
}
.enterbtn.enter {
  border: 1px solid #ededed;
  padding: 18px 50px;
  color: #061a3a;
  box-shadow: none;
}

.enterbtn.enter:hover {
  color: #4184f3;
  box-shadow: 0px 15px 40px 0px rgba(32, 81, 171, 0.2);
}
/* animate */

.fx-border {
  position: relative;
  overflow: hidden;
}

.fx-border:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: " ";
  background-color: #4184f3;
  transition: ease-in-out all 0.3s;
  visibility: hidden;
  transform: scale(0.7);
  opacity: 0;
}

.fx-border:hover > * {
  color: white;
  transition: 0.5s;
}
.fx-border:hover h4 a {
  color: white;
}
.fx-border:hover .icon {
  background-color: white;
}
.fx-border:hover:before {
  visibility: visible;
  transform: scale(1);
  opacity: 1;
}

.fx-border > * {
  position: relative;
  z-index: 2;
  transition: all 0.3s;
}

[class*="fx-border-"] {
  position: absolute;
  background: #fff;
  opacity: 0;
  pointer-events: none;
}

.fx-border-top {
  top: 15px;
  width: 0;
  height: 1px;
  right: 15px;
  transition: all 0.5s;
}

.fx-border-right {
  top: 15px;
  right: 15px;
  width: 1px;
  height: 0;
  transition: all 0.7s;
}

.fx-border-bottom {
  bottom: 15px;
  width: 0;
  height: 1px;
  left: 15px;
  transition: all 0.9s;
}

.fx-border-left {
  top: 15px;
  left: 15px;
  width: 1px;
  height: 0;
  transition: all 1.1s;
}

.feature:hover > [class*="fx-border-"] {
  opacity: 1;
}

.feature:hover > .fx-border-top {
  width: calc(100% - 30px);
}

.feature:hover > .fx-border-right {
  height: calc(100% - 30px);
}

.feature:hover > .fx-border-bottom {
  width: calc(100% - 30px);
}

.feature:hover > .fx-border-left {
  height: calc(100% - 30px);
}
.centertitle {
  margin-top: 45px;
  margin-bottom: 30px;
  text-align: center;
}
.centertitle:after {
  content: "";
  display: block;
  width: 45px;
  height: 6px;
  background-color: #4184f3;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  margin: 20px auto 0 auto;
}

@media (min-width: 1560px) {
  .content_div {
    width: 1440px;
  }
  .link-btn {
    left: 100px;
  }
}
@media (min-width: 1420px) {
  @media (max-width: 1560px) {
    .content_div {
      width: 1260px;
    }
    .link-btn {
      left: 76px;
    }
  }
}
@media (min-width: 1200px) {
  @media (max-width: 1420px) {
    .content_div {
      width: 1080px;
    }
    .link-btn {
      left: 56px;
    }
  }
}
@media (min-width: 1000px) {
  @media (max-width: 1200px) {
    .content_div {
      width: 960px;
    }
    .link-btn {
      left: 82px;
    }
  }
}
@media (max-width: 1000px) {
  .content_div {
    width: 855px;
  }
  .link-btn {
    left: 140px;
  }
  #_type {
    width: 1024px;
  }
}

.link-btn {
  cursor: pointer;
  position: absolute;
  bottom: 32px;
}

.text {
  height: 72px;
  font-size: 12px;
  color: #333;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.card:hover .text {
  color: white;
}

.card:hover .over:after {
  content: "...";
  opacity: 0;
  background: #4184f3;
  transition: 0.2s;
}
#_type /deep/.ivu-back-top-inner {
  background-color: #4184f4;
  opacity: 1;
  box-shadow: 0 3px 24px rgba(0, 0, 0, 0.04);
  animation: myfirst 5s;
  -webkit-animation: myfirst 0.7s; /* Safari and Chrome */
}
#_type /deep/.ivu-back-top-inner:hover {
  background-color: #4184f4;
  opacity: 0.8;
}

@keyframes myfirst {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes myfirst /* Safari and Chrome */ {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}



//首页
.headwapper{
  margin-top: 120px;
  margin-bottom: 100px;
}
.showdate{
  display: inline-block;
  font-size: 10px;
}
.tslctline{
  margin-bottom: 10px;
}
.timerange{
  margin: 0;
  line-height: normal;
  padding: 7px 16px;
  clear: both;
  color: #515a6e;
  font-size: 12px!important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background .2s ease-in-out;
  margin-top: 5px;
  border-top: 1px solid #e8eaec;
}

</style>
<script>
import axios from "@/api/axios"
import { mapState, mapActions, mapMutations } from "vuex";
import SearchInput from "@/components/search/searchInput";
export default {
  components: {SearchInput},
  data () {
    return {
      showmodal: false,
      systemList: [],
      stockList: [],
      //选择后的股票代码
      model: [],
      year:'年份不限',
      code:'股票代码',
      //开始年份
      startDate: '',
      //结束年份
      endDate: '',
      //要搜索哪个库，需要拼音
      database: 'nianbao',
      //搜索关键字
      keyword: '',
      dataload: false,
      dataType: "cipin",
      timeSelect: "NoLimit",
      headerList: [],
      
    };
  },
 
  computed: {
    ...mapState(["moduleSystem"]),
    currentModuleSystem () {
      if (this.moduleSystem[this.list[this.count].name]) {
        return this.moduleSystem[this.list[this.count].name];
      } else {
        return [];
      }
    }
  },
  created() {
    this.keyword = this.searchKeyWord
    const codeurl = "/stockIdTable.json"
    axios.get(codeurl).then(res=>{
      let dataArray = res.data;
      for (var i = 0; i < dataArray.length; i++) {
        var oneDataObj = dataArray[i];
        this.stockList.push(oneDataObj);
      }
    }).catch(err=>{
      console.log(err);
    })
  },
  methods: {
    showHistoryModel() {
      this.$emit('showHistory')
    },
    setDatabase(database){
      this.database = database
    },
    ...mapActions(["getModuleSystemn"]),
    ...mapMutations(["SET_MODULESYSTEMN"]),
    changeShowModel () {
      this.showmodal = false
    },
    gotoTarget (type, mokuai) {
      //在访问之前请求后端，拿到当前反问数据库的访问级别,如果是公开数据库，则可以直接访问，
      //如果是非公开的数据库，则需请求权限访问(未写)
      if (this.systemList === [] || this.systemList.length === 0) {
        axios.get("/api/getSystemList").then(res => {
          var systemmap = res.data.SystemList;
          for (var key in systemmap) {
            this.systemList.push(systemmap[key])
          }
          let itemList = this.systemList.filter(
            s => {
              return (s.module === type && s.system === mokuai)
            }
          )
          console.warn(itemList)
          if (itemList.length === 1) {
            // const key = Object.keys(itemList[0].tableInfo)[1];
            // let pushPath = "/" + key.substring(key.indexOf("-") +1, key.length)
            this.$router.push({
              path: '/views/' + type + '/' + mokuai + (mokuai === 'CFND_HighTrail' ? '/报刊财经新闻基本信息' : mokuai === 'GUBA_CNRDS' ? '/股吧文章统计_按交易时间' : '/analysis')
            })
          } else {
            this.showmodal = true
          }
        }).catch(err => {
          console.log(err);
        })
      } else {
        let item = this.systemList.filter(
          s => {
            return (s.module === type && s.system === mokuai)
          }
        )

        if (item.length === 1) {
          this.$router.push({
            path: '/views/' + type + '/' + mokuai + '/analysis'
          })
        } else {
          this.showmodal = true;
        }
      }
      document.getElementsByClassName('scrollbar')[0].scrollTop = 0
    },
    maxTagPlaceholder (num) {
      return '已选 '+ num;
    },
    starthandleChange (date) {
      this.startDate = date;
      this.year = this.startDate + ' - ' + this.endDate;
    },
    endhandleChange (date) {
      this.endDate = date;
      this.year = this.startDate + ' - ' + this.endDate;
    },

    
    
  }
};
</script>

